import React from 'react';
//CarbonComponents
import {
  DataTable,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  SkeletonText,
  TableRow
} from 'carbon-components-react';

interface Props {
  isFullSet?: boolean;
  selectedRowHandler: Function;
  title?: string;
  description?: string;
  rows: any[];
  headers?: any[];
  isLoading?: boolean;
  size?: string;
}

export const DataTableBasicMobileViewCommponent: React.FC<Props> = ({
  isFullSet,
  selectedRowHandler,
  title,
  description,
  headers,
  rows,
  size
}: any) => {
  const renderStatus = (value: any) => {
    let statusElement = null;

    if (typeof value === 'string') {
      statusElement = (
        <div className={`row--sub-header${isFullSet ? '-full' : ''}`}>
          {value}
          {isFullSet ? ' responses received' : ''}
        </div>
      );
    } else {
      statusElement = Object.keys(value).map((key, i) => {
        if (key === 'status') {
          return (
            <div
              key={i}
              className={`row--sub-header${isFullSet ? '-full' : ''}`}
            >
              {value[key]}
              {isFullSet ? ' responses received' : ''}
            </div>
          );
        } else {
          return <div key={i}>{value[key]}</div>;
        }
      });
    }

    return statusElement;
  };
  return (
    <DataTable size={size || 'normal'} rows={rows} headers={headers || []}>
      {({ rows, getRowProps, getTableProps, getTableContainerProps }: any) => (
        <TableContainer
          className="mobile-table"
          title={title}
          description={description}
          {...getTableContainerProps()}
        >
          <Table size={size || 'normal'} {...getTableProps()}>
            <TableBody>
              {rows?.length === 0 ? (
                <React.Fragment>
                  <TableRow>
                    <SkeletonText key={`sm_1`} />
                  </TableRow>
                  <TableRow>
                    <SkeletonText key={`sm_2`} />
                  </TableRow>
                  <TableRow>
                    <SkeletonText key={`sm_3`} />
                  </TableRow>
                </React.Fragment>
              ) : (
                rows.map((row: any, i: any) => {
                  const cells = row.cells;
                  const c_0 = cells[0],
                    c_1 = cells[1],
                    c_2 = cells[2],
                    c_3 = cells[3];

                  return (
                    <React.Fragment key={row.id}>
                      <TableRow
                        {...getRowProps({ row })}
                        onClick={() =>
                          selectedRowHandler && selectedRowHandler(row)
                        }
                      >
                        <TableCell key={cells[i]?.info?.header}>
                          <div className="row--header">
                            Job {c_0?.value?.job}
                            {c_1?.value && c_1.value !== c_2?.value
                              ? ` (${c_1.value})`
                              : c_2?.value
                              ? ` (${c_2.value})`
                              : ''}
                          </div>
                          {!isFullSet &&
                            c_2?.value &&
                            c_1.value !== c_2?.value && (
                              <div key={i} className="row--sub-header">
                                {c_2.value}
                              </div>
                            )}
                          {renderStatus(c_3?.value)}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </DataTable>
  );
};

export default React.memo(DataTableBasicMobileViewCommponent);
